module.exports = __webpack_public_path__ + "img/img1.377d34c9.png";